// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"snackbar_snackbar__CaNzy","success":"snackbar_success__2-Df2","error":"snackbar_error__rOpXu","snackbarIcon":"snackbar_snackbarIcon__3GHXm"};